import React from 'react'
import NumberFormat from 'react-number-format'
import { ACCOUNT_CARD_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function AccountDisplay({ currentAccountDetail = {} }) {
  const { t } = useTranslation()
  return (
    <div className='d-flex source-account-section'>
      <div className='image'></div>
      <div>
        <label>{t(ACCOUNT_CARD_KEYS.SOURCE_ACCOUNT)}</label>
        <h3>{currentAccountDetail?.accountNo}</h3>
        <p>
          {t(ACCOUNT_CARD_KEYS.AVAILABLE_BALANCE)}:{' '}
          <span style={{ marginRight: 5 }}>{currentAccountDetail?.currency}</span>
          <NumberFormat
            value={currentAccountDetail?.avlBal}
            displayType={'text'}
            thousandSeparator={true}
            prefix={''}
            fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
          />
        </p>
      </div>
    </div>
  )
}
